import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/_service/shared.service';
import { TpaService } from 'src/app/_service/tpa.service';

@Component({
  selector: 'app-add-edittpa',
  templateUrl: './add-edittpa.component.html',
  styleUrls: ['./add-edittpa.component.css']
})
export class AddEdittpaComponent implements OnInit {

  tpaForm: FormGroup;submitted = false;loading:boolean=false;TpaId: any = '';

  constructor(private formBuilder: FormBuilder, private activateRoute: ActivatedRoute, private tpa: TpaService, private sharedapi:SharedService, private router:Router) {
    this.tpaForm = this.formBuilder.group({
      'name': [null, Validators.required],
      'status': [null, Validators.required]
    });

    this.activateRoute.params.subscribe(params => {
      if(params['tpa_id']) {
        this.TpaId = params['tpa_id'];
        this.patchTpaData();
      }
    })
  }

  ngOnInit(): void {
  }

  get f() { return this.tpaForm.controls; }

  patchTpaData(){
    this.tpa.getTpa(this.TpaId).subscribe((response:any) => {
      if(response.status) {
        this.tpaForm.patchValue({
          'name': response.data.name,
          'status': response.data.status
        });
      }
    });
  }

  async createTpa(){
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.tpaForm.invalid) {
        this.loading = false;
        return;
    }

    if(this.TpaId) {
      this.tpaForm.value.id = parseInt(this.TpaId);
      await this.tpa.updateTpa(this.tpaForm.value).subscribe((response:any) =>{
        this.submitted = false;
        this.loading = false;
        if(response.status) {
          this.sharedapi.presentToast('Tpa Update Successfully');
          this.router.navigateByUrl('/tpa');
        } else {
          this.sharedapi.presentToast(response.msg);
        }
      }, error => {
          this.sharedapi.checkError(error);
      });
    } else {
      await this.tpa.addTpa(this.tpaForm.value).subscribe((response:any) =>{
        this.submitted = false;
        this.loading = false;
        if(response.status) {
          this.sharedapi.presentToast('Tpa Added Successfully');
          this.router.navigateByUrl('/tpa');
        } else {
          this.sharedapi.presentToast(response.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }
  }

}
